import { FormInstance } from "antd"
import { UploadComponent } from "components"
import { DefaultLinksRouting } from "components/defaultLinksRouting"
import { FC, useEffect, useState } from "react"
import { useStore } from "stores/utils/use-store"
import { GeoImagesEditor } from "../../geoImagesEditor"
import { ContestConfig } from "domains/managingJson/store/types"

export const ImagesTab: FC<{form: FormInstance<any>, selectedGames: string[] | undefined}> = ({ form, selectedGames }) => {

  const { dataStore: { managingJsonStore: { selectedElement } } } = useStore()
  const data = selectedElement.data as ContestConfig

  const [, refreshState] = useState(0)
  const refresh = () => refreshState(e => e + 1)

  useEffect(() => {
    refresh()
  }, [selectedGames])

  useEffect(() => {
    data.endgameWindow === undefined ? data.endgameWindow = {
      endgameSuccessImage: "",
      endgameFraudImage: "",
      endgameFailImage: "",
      gameBackgroundImage: "",
    } : ""

    data.startgameWindow === undefined ? data.startgameWindow = { contestImage: "" } : ""
  }, [data])

  return (
    <div style={{ background: "#F0F2F5", margin: "-16px", padding: "24px 48px" }}>
      <div style={{ background: "#FFFFFF", padding: "24px 16px", marginBottom: "24px" }}>
        <div style={{ fontWeight: "500", marginBottom: "24px" }}>Main Images</div>
        <div style={{ display: "flex", marginBottom: "24px" }}>
          <div style={{ width: "33%", marginRight: "8px" }}>
            <UploadComponent
              name="mainLogo"
              image={data.mainLogo ?? ""}
              setImage={e => {
                refresh()
                data.mainLogo = e
              }}
              placeholder=""
              title="Main Logo"
            />
          </div>
          <div style={{ width: "33%", marginRight: "8px" }}>
            <UploadComponent
              image={data.advImage ?? ""}
              setImage={e => {
                refresh()
                data.advImage = e
              }}
              placeholder=""
              title="ADS block placeholder"
            />
          </div>
          <div style={{ width: "33%" }}>
            <UploadComponent
              image={data.settingsLogo ?? ""}
              setImage={e => {
                refresh()
                data.settingsLogo = e
              }}
              placeholder=""
              title="Settings Logo"
            />
          </div>
        </div>
        <div style={{ display: "flex" }}>
          <div style={{ width: "50%", marginRight: "8px" }}>
            <UploadComponent
              image={data.topBarLogo ?? ""}
              setImage={e => {
                refresh()
                data.topBarLogo = e
              }}
              placeholder=""
              title="Top Bar Logo"
            />
          </div>
          {selectedGames?.length === 1 && (
            <div style={{ width: "50%" }}>
              <UploadComponent
                image={data.gameTitleImage ?? ""}
                setImage={e => {
                  refresh()
                  data.gameTitleImage = e
                }}
                placeholder=""
                title="Game Title Image"
              />
              <div style={{ marginBottom: "16px" }}>
                <label style={{ display: "block", marginBottom: "8px", fontWeight: "500" }}>
                  Game Title Image URL
                </label>
                <DefaultLinksRouting
                  link={data.gameTitleImageURL || ""}
                  formItemName="gameTitleImageURL"
                  notRequired
                  onChange={value => {
                    data.gameTitleImageURL = value
                    refresh()
                  }}
                />
              </div>
            </div>
          )}
        </div>
        {selectedGames?.length === 1 && (
          <div style={{ display: "flex" }}>
            <div style={{ width: "50%" }}>
              <UploadComponent
                image={data.gameTitleImageWinnersList ?? ""}
                setImage={e => {
                  refresh()
                  data.gameTitleImageWinnersList = e
                }}
                placeholder=""
                title="Game Title Image Winners List"
              />
              <div style={{ marginBottom: "16px" }}>
                <label style={{ display: "block", marginBottom: "8px", fontWeight: "500" }}>
                  Game Title Image Winners List URL
                </label>
                <DefaultLinksRouting
                  link={data.gameTitleImageWinnersListURL || ""}
                  formItemName="gameTitleImageWinnersListURL"
                  notRequired
                  onChange={value => {
                    data.gameTitleImageWinnersListURL = value
                    refresh()
                  }}
                />
              </div>
            </div>
          </div>
        )}
      </div>
      <div style={{ background: "#FFFFFF", padding: "24px 16px", marginBottom: "24px" }}>
        <div style={{ fontWeight: "500", marginBottom: "24px" }}>Start / End Game Windows</div>
        <div style={{ display: "flex", marginBottom: "24px" }}>
          <div style={{ width: "33%", marginRight: "8px" }}>
            <UploadComponent
              image={data.endgameWindow?.endgameSuccessImage ?? ""}
              setImage={e => {
                refresh()
                data.endgameWindow ? data.endgameWindow.endgameSuccessImage = e : ""
              }}
              placeholder=""
              title="End Game Succes"
            />
          </div>
          <div style={{ width: "33%", marginRight: "8px" }}>
            <UploadComponent
              image={data.endgameWindow?.endgameFraudImage ?? ""}
              setImage={e => {
                refresh()
                data.endgameWindow ? data.endgameWindow.endgameFraudImage = e : ""
              }}
              placeholder=""
              title="End Game Fraud"
            />
          </div>
          <div style={{ width: "33%" }}>
            <UploadComponent
              image={data.endgameWindow?.endgameFailImage ?? ""}
              setImage={e => {
                refresh()
                data.endgameWindow ? data.endgameWindow.endgameFailImage = e : ""
              }}
              placeholder=""
              title="End Game Fail"
            />
          </div>
        </div>
        <div style={{ width: "33%", marginRight: "8px" }}>
          <UploadComponent
            image={data.startgameWindow?.contestImage ?? ""}
            setImage={e => {
              refresh()
              data.startgameWindow ? data.startgameWindow.contestImage = e : ""
            }}
            placeholder=""
            title="Start Game Contest"
          />
        </div>
      </div>
      {data.contestType === "CHALLENGE_BASED" && (
        <div style={{ background: "#FFFFFF", padding: "24px 16px", marginBottom: "24px" }}>
          <div style={{ fontWeight: "500", marginBottom: "24px" }}>Challenge Images</div>
          <div style={{ display: "flex", marginBottom: "24px" }}>
            <div style={{ width: "50%", marginRight: "8px" }}>
              <UploadComponent
                image={data.challengeBasedContest?.progressBlockImage ?? ""}
                setImage={e => {
                  refresh()
                  if (data.challengeBasedContest) {
                    data.challengeBasedContest.progressBlockImage = e
                  }
                }}
                placeholder=""
                title="Progress Block Image"
              />
            </div>
            <div style={{ width: "50%", marginRight: "8px" }}>
              <UploadComponent
                image={data.challengeBasedContest?.winnersListImageBottom ?? ""}
                setImage={e => {
                  refresh()
                  if (data.challengeBasedContest) {
                    data.challengeBasedContest.winnersListImageBottom = e
                  }
                }}
                placeholder=""
                title="Winners List Image Bottom"
              />
              <div style={{ marginBottom: "16px" }}>
                <label style={{ display: "block", marginBottom: "8px", fontWeight: "500" }}>
                  Winners List Image Bottom URL
                </label>
                <DefaultLinksRouting
                  link={data.challengeBasedContest?.winnersListImageBottomURL || ""}
                  formItemName="winnersListImageBottomURL"
                  notRequired
                  onChange={value => {
                    if (data.challengeBasedContest) {
                      data.challengeBasedContest.winnersListImageBottomURL = value
                    }
                    refresh()
                  }}
                />
              </div>
            </div>
            <div style={{ width: "50%" }}>
              <UploadComponent
                image={data.challengeBasedContest?.winnersListImageTable ?? ""}
                setImage={e => {
                  refresh()
                  if (data.challengeBasedContest) {
                    data.challengeBasedContest.winnersListImageTable = e
                  }
                }}
                placeholder=""
                title="Winners List Image Table"
              />
              <div style={{ marginBottom: "16px" }}>
                <label style={{ display: "block", marginBottom: "8px", fontWeight: "500" }}>
                  Winners List Image Table URL
                </label>
                <DefaultLinksRouting
                  link={data.challengeBasedContest?.winnersListImageTableURL || ""}
                  formItemName="winnersListImageTableURL"
                  notRequired
                  onChange={value => {
                    if (data.challengeBasedContest) {
                      data.challengeBasedContest.winnersListImageTableURL = value
                    }
                    refresh()
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      <div style={{ background: "#FFFFFF", padding: "24px 16px" }}>
        <div style={{ fontWeight: "500", marginBottom: "24px" }}>Leaderboard</div>
        <div style={{ display: "flex", marginBottom: "24px" }}>
          <div style={{ width: "33%", marginRight: "8px" }}>
            <UploadComponent
              image={data.leaderboardBanner ?? ""}
              setImage={e => {
                refresh()
                data.leaderboardBanner = e
              }}
              placeholder=""
              title="Leaderboard Banner"
            />
          </div>
          <div style={{ width: "33%" }}>
            <UploadComponent
              image={data.leaderboardAdReplacementBanner ?? ""}
              setImage={e => {
                refresh()
                data.leaderboardAdReplacementBanner = e
              }}
              placeholder=""
              title="Ad Replacement Banner"
            />
          </div>
        </div>

        <div style={{ display: "flex" }}>
          <div style={{ marginRight: "10px", width: "48%" }}>
            <GeoImagesEditor
              parentIndex={1}
              form={form}
              title="Top Banner"
              objectKey="leaderboardTopBannerCountry"
            />
            <div style={{ marginTop: "8px", marginRight: "10px" }}>
                Leaderboard Top Banner Copy Text
              <DefaultLinksRouting
                link={data.leaderboardBanners?.topBannerCopyText || ""}
                formItemName="topCopyText"
                notRequired
                onChange={value => {
                  if (!data.leaderboardBanners) {
                    data.leaderboardBanners = { rightBannerCopyText: "", topBannerCopyText: "" }
                  }
                  data.leaderboardBanners.topBannerCopyText = value
                  refresh()
                }}
              />
            </div>
          </div>
          <div style={{ marginRight: "10px", width: "48%" }}>
            <GeoImagesEditor
              parentIndex={1}
              form={form}
              title="Schedule Right Side Bannner"
              objectKey="leaderboardBannerCountry"
            />
            <div style={{ marginTop: "8px" }}>
                Leaderboard Right Banner Copy Text
              <DefaultLinksRouting
                link={data.leaderboardBanners?.rightBannerCopyText || ""}
                formItemName="rightCopyText"
                notRequired
                onChange={value => {
                  if (!data.leaderboardBanners) {
                    data.leaderboardBanners = { rightBannerCopyText: "", topBannerCopyText: "" }
                  }
                  data.leaderboardBanners.rightBannerCopyText = value
                  refresh()
                }}
              />
            </div>
          </div>
        </div>

      </div>
    </div>
  )

}
